// extracted by mini-css-extract-plugin
export default {"wrapper":"RqQYPgQJKGQEAhQ629E+zg==","mainOnly":"ZW7Pq0ygbN8wDJELj8EBjA==","mainInner":"Ymef9aD8ePAWmYi36e9udg==","asideWrapper":"ysCNH8k1JpS0XhuFVPkTYQ=="};